/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable no-undef */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Avatar_16,
  Avatar_02,
  Avatar_05,
  Avatar_09,
  Avatar_10,
} from "../../../Routes/ImagePath/index";

import { Link } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";

import React, { useState, useEffect } from "react";

import AuthUser from "../../AuthUser";

import { toast, ToastContainer } from "react-toastify";

import Spinner from "../../Spinner";

import Swal from "sweetalert2";

const AnexarDocumentoModal = ({ anexo, tipo_documentos, user_id }) => {
  const { t } = useTranslation();

  // eslint-disable-next-line no-unused-vars
  const {
    http,
    url_root,
    user,
    user_permissoes,
    verificarPermissao,
    getMissao,
  } = AuthUser();

  const [tipo, setTipo] = useState("-1");

  const [imagem, setSelectedFile] = useState(null);
  const [imagemPreview, setimagemPreview] = useState();

  const [tipo_documento_id, setTipoDocumentoID] = useState(-1);

  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const [data1, setData1] = useState('2025-01-01');
  const [data2, setData2] = useState('2099-12-31');

  const [inputs, setInputs] = useState(anexo);

  const toggleLoading = (value) => {
    setLoading(value);
  };

  const triggerCloseButtonClick = (buttonId) => {
    const closeButton = document.getElementById(buttonId);
    if (closeButton) {
      closeButton.dispatchEvent(new Event("click"));
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setSelectedFile(null);
        setInputs(anexo);
        setimagemPreview(url_root + "/storage/" + anexo?.tipo_anexo?.imagem);
        setTipoDocumentoID(anexo?.tipo_anexo?.id);
        setData1(anexo?.dataEmissao);
        setData2(anexo?.dataExpira);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [anexo]);

  const update_anexo = async () => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("id", inputs?.id);
      formData.append("tipo_anexo", tipo_documento_id);
      formData.append("data1", data1);
      formData.append("data2", data2);

      // Append each file separately
      if (imagem)
        for (let i = 0; i < imagem.length; i++) {
          formData.append("files[]", imagem[i]);
        }

      const response = await http.post(
        "/anexo-do-colaborador/update",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      triggerCloseButtonClick("closeButton40");

      // Show a success toast
      toast.success(response.data.message, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        onClose: () => {
          setLoading(false);
        },
      });
    } catch (error) {
      console.error(error);

      toast.error(
        "Ocorreu um erro ao carregar o tipo_documentos. Por favor, tente novamente mais tarde.",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    }
  };

  const handleInputsValueChanged = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    setInputs((prevInputs) => ({
      ...prevInputs,
      [name]: value,
    }));
  };

  /* Imagem do logotipo */

  const handleTipoDocumentoChange = (item) => {
    // Chamar uploadFiles() apenas se houver arquivos selecionados
    setTipoDocumentoID(item);
  };

  const handleFileChange = (e, filho_id) => {
    const newFile = e.target.files;

    // Lógica para processar a imagem, se necessário
    setSelectedFile(newFile);
  };

  const uploadFilesGeral = async () => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("missao_id", getMissao()?.id);
      formData.append("descricao", " Anexos do colaborador ");
      formData.append("para_id", user_id);
      formData.append("tipo", 5); //Utilizador
      formData.append("filho_id", 0);
      formData.append("data1", data1);
      formData.append("data2", data2);
      formData.append("tipo_anexo", tipo_documento_id);

      // Append each file separately
      if (imagem)
        for (let i = 0; i < imagem.length; i++) {
          formData.append("files[]", imagem[i]);
        }

      const response = await http.post("/criar-arquivo", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      triggerCloseButtonClick("closeButton30");

      // Show a success toast
      toast.success(response.data?.message, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        onClose: () => {},
      });

      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const renderOptionTipoDocumentos = (clientes) => {
    return clientes?.map((cliente) => (
      <React.Fragment key={cliente.id}>
        <option value={cliente.id}>{cliente.designacao}</option>
      </React.Fragment>
    ));
  };

  return (
    <>
      {/* Add Task Modal */}
      <div
        id="add_tipo_documento_modal"
        className="modal custom-modal fade"
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{t("Add Anexo")}</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                id="closeButton30"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="input-block mb-3 form-focus focused">
                  <label className="col-form-label focus-label">
                    {t("Uplaod anexo")}
                  </label>
                  <input
                    type="file"
                    className="upload"
                    name="files[]"
                    onChange={(e) => handleFileChange(e)}
                    id="files_edit"
                    multiple="multiple"
                  />
                </div>

                <div className="input-block mb-3 mt-5 form-focus focused">
                  <label className="focus-label">
                    {t("Tipo de documento")}
                  </label>
                  <select
                    onChange={(e) => handleTipoDocumentoChange(e.target.value)}
                    value={tipo_documento_id}
                    className="form-control select"
                  >
                    <option key={0} value={-1}></option>
                    {renderOptionTipoDocumentos(tipo_documentos)}
                  </select>
                </div>

                  <div className="input-block mb-3 form-focus focused">
                    <label className="focus-label">Data emissão ( opcional ) </label>
                    <input
                      className="form-control"
                      type="date"
                      value={data1}
                      onChange={(e) => setData1(e.target.value)}
                    />
                  </div>
                  <div className="input-block mb-3 form-focus focused">
                    <label className="focus-label">Data expiração ( opcional )</label>
                    <input
                      className="form-control"
                      type="date"
                      value={data2}
                      onChange={(e) => setData2(e.target.value)}
                    />
                  </div>

                <div className="submit-section m-t-20 text-center">
                  {loading ? (
                    "A processar"
                  ) : (
                    <span
                      className="btn btn-primary"
                      onClick={() => uploadFilesGeral()}
                    >
                      {t("Submit")}
                    </span>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Task Modal */}

      {/* Edit Task Modal */}
      <div
        id="edit_tipo_documento_modal"
        className="modal custom-modal fade"
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{t("Editar Tipo De Documento")}</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                id="closeButton40"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="col-sm-12">
                  <div className="input-block mb-3 form-focus focused">
                    <label className="col-form-label focus-label">
                      {t("Uplaod anexo")}
                    </label>
                    <input
                      type="file"
                      className="upload"
                      name="files[]"
                      onChange={(e) => handleFileChange(e)}
                      id="files_edit"
                      multiple="multiple"
                    />
                  </div>
                </div>

                <div className="input-block mb-3 mt-5 form-focus focused">
                  <label className="focus-label">
                    {t("Tipo de documento")}
                  </label>
                  <select
                    onChange={(e) => handleTipoDocumentoChange(e.target.value)}
                    value={tipo_documento_id}
                    className="form-control select"
                  >
                    <option key={0} value={-1}></option>
                    {renderOptionTipoDocumentos(tipo_documentos)}
                  </select>
                </div>


                  <div className="input-block mb-3 form-focus focused">
                    <label className="focus-label">Data emissão ( opcional ) </label>
                    <input
                      className="form-control"
                      type="date"
                      value={data1}
                      onChange={(e) => setData1(e.target.value)}
                    />
                  </div>
                  <div className="input-block mb-3 form-focus focused">
                    <label className="focus-label">Data expiração ( opcional )</label>
                    <input
                      className="form-control"
                      type="date"
                      value={data2}
                      onChange={(e) => setData2(e.target.value)}
                    />
                  </div>

                <div className="submit-section m-t-20 text-center">
                  {loading ? (
                    "A processar"
                  ) : (
                    <span
                      className="btn btn-primary"
                      onClick={() => update_anexo()}
                    >
                      {t("Save")}
                    </span>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Task Modal */}

      <ToastContainer />
    </>
  );
};

export default AnexarDocumentoModal;
